import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  DatePicker,
  Button,
  InputNumber,
  Space,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  displayFormattedDate,
  formatDateToDayJS,
  getClientConfig,
  getCreditors,
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import TableComponent from "../../common/table/TableComponent";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

function AddOnAccountPayment() {
  const innerColumns = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Payment Amount",
      dataIndex: "billAmount",
    },
    {
      title: "TDS",
      dataIndex: "tds",
      render: (text, record) => (
        <InputNumber
          placeholder="TDS"
          onChange={(e) => saveTDS(e, record.id)}
          value={text}
        ></InputNumber>
      ),
      width: "200px",
    },
    {
      title: "Cheque Number",
      dataIndex: "chequeNumber",
      render: (text, record) => (
        <Input
          placeholder="Cheque Number"
          onChange={(e) => saveChequeNumber(e, record.id)}
          value={text}
        ></Input>
      ),
      width: "300px",
    },
  ];

  const outerColumns = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
    },
    {
      title: "Payment Amount",
      dataIndex: "billAmount",
    },
    {
      title: "TDS",
      dataIndex: "tds",
      render: (text) => text,
    },
    {
      title: "Cheque Number",
      dataIndex: "chequeNumber",
      render: (text) => text,
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => deleteRecord(record)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const location = useLocation();

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [visible, setVisible] = useState();
  const [innerTableData, setInnerTableData] = useState();
  const [outerTableData, setOuterTableData] = useState();
  const [tdsMaping, setTDSMaping] = useState([]);
  const [chequeNumberMaping, setChequeNumberMaping] = useState([]);
  const [inititalVals, setInitialVals] = useState();

  const [response, request] = useApi(
    "/onAccountPayment",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/onAccountPayment`,
    null,
    API_METHODS.PUT
  );
  const [
    directPurchaseWithoutOnAccountPayment,
    geDirectPurchaseWithoutOnAccountPayment,
  ] = useApi("/directPurchase/onAccountPaymentNotDone", null, API_METHODS.GET);

  const [onAccountPaymentData, getOnAccountPaymentData] = useApi(
    "/onAccountPayment/",
    null,
    API_METHODS.GET
  );

  const { account, voucherType } = getClientConfig();
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);

  const saveTDS = (e, billId) => {
    const newMapping = [...tdsMaping];
    const found = newMapping.findIndex((record) => record.billId === billId);
    if (found === -1) {
      newMapping.push({ billId: billId, tds: e });
    } else {
      newMapping[found].tds = e;
    }
    setTDSMaping(newMapping);
    let newInnerTableData = innerTableData;
    var foundIndex = newInnerTableData.findIndex((data) => data.id == billId);
    newInnerTableData[foundIndex].tds = e;
    setInnerTableData(newInnerTableData);
  };

  const saveChequeNumber = (e, billId) => {
    const newMapping = [...chequeNumberMaping];
    const found = newMapping.findIndex((record) => record.billId === billId);
    if (found === -1) {
      newMapping.push({ billId: billId, chequeNumber: e.target.value });
    } else {
      newMapping[found].chequeNumber = e.target.value;
    }
    setChequeNumberMaping(newMapping);
    let newInnerTableData = innerTableData;
    var foundIndex = newInnerTableData.findIndex((data) => data.id == billId);
    newInnerTableData[foundIndex].chequeNumber = e.target.value;
    setInnerTableData(newInnerTableData);
  };

  const deleteRecord = (record) => {
    const selectedBills = outerTableData.filter((bill) => bill !== record);
    let amount = 0;
    let tds = 0;
    let newSelectedRowKeys = selectedRowKeys;

    const index = newSelectedRowKeys.indexOf(record.id);
    if (index > -1) {
      newSelectedRowKeys.splice(index, 1);
    }

    for (let i = 0; i < selectedBills.length; i++) {
      amount = amount + selectedBills[i].billAmount;
      tds = selectedBills[i].tds ? tds + selectedBills[i].tds : tds;
    }
    form.setFieldsValue({ amount, tds });
    setOuterTableData(selectedBills);
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedBills);
  };

  const previousButtonClicked = () => {
    let payment_id = form.getFieldValue("id") - 1;
    getOnAccountPaymentData(
      null,
      API_METHODS.GET,
      `/onAccountPayment/${payment_id}`
    );
  };
  const nextButtonClicked = () => {
    let payment_id = form.getFieldValue("id") + 1;
    getOnAccountPaymentData(
      null,
      API_METHODS.GET,
      `/onAccountPayment/${payment_id}`
    );
  };

  const onFinish = () => {
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        setLoadingSaveButton(true);
        if (outerTableData && outerTableData.length > 0) {
          values.directPurchaseIds = outerTableData.map((bill) => ({
            id: bill.id,
            tds: bill.tds,
            chequeNumber: bill.chequeNumber,
          }));
        }
        if (location && location.state) {
          values.paymentDate = formatDateToDayJS(values.paymentDate);
          editRequest(
            values,
            API_METHODS.PUT,
            `/onAccountPayment/${location.state.on_account_payment_id}`
          );
        } else {
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  useEffect(() => {
    const data =
      directPurchaseWithoutOnAccountPayment.data !== BLANK_VALUE
        ? directPurchaseWithoutOnAccountPayment.data
        : [];
    setInnerTableData(data);
  }, [directPurchaseWithoutOnAccountPayment]);

  useEffect(() => {
    if (editResponse.data) {
      message.success("On Account Payment updated successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/onAccountPayment");
    }
  }, [editResponse]);

  useEffect(() => {
    if (response.data) {
      message.success("On Account Payment added successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/onAccountPayment");
    }
  }, [response]);

  useEffect(() => {
    if (location.state && location.state.on_account_payment_id) {
      getOnAccountPaymentData(
        null,
        API_METHODS.GET,
        `/onAccountPayment/${location.state.on_account_payment_id}`
      );
    }
  }, [location.state]);

  useEffect(() => {
    let initialValues =
      onAccountPaymentData &&
      onAccountPaymentData.data &&
      onAccountPaymentData.data[0];

    if (initialValues) {
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.paymentDate = formatDateToDayJS(initialValues.paymentDate);
      form.setFieldsValue(initialValues);
      geDirectPurchaseWithoutOnAccountPayment(
        null,
        API_METHODS.GET,
        `/directPurchase/onAccountPaymentNotDone/${initialValues.accountId}`
      );

      setInitialVals(initialValues);

      if (!isEmpty(initialValues.directPurchaseData)) {
        setOuterTableData(initialValues.directPurchaseData);
        let keys = [];
        for (let i = 0; i < initialValues.directPurchaseData.length; i++) {
          keys.push(initialValues.directPurchaseData[i].id);
        }
        setSelectedRows(initialValues.directPurchaseData);
        setSelectedRowKeys(keys);
      }
    } else if (onAccountPaymentData.error) {
      navigate("/portal/onAccountPayment");
    }
  }, [onAccountPaymentData]);

  const accountChanged = (accountId) => {
    geDirectPurchaseWithoutOnAccountPayment(
      null,
      API_METHODS.GET,
      `/directPurchase/onAccountPaymentNotDone/${accountId}`
    );

    if (location.state && accountId === inititalVals.accountId) {
      let keys = [];
      for (let i = 0; i < inititalVals.directPurchaseData.length; i++) {
        keys.push(inititalVals.directPurchaseData[i].id);
      }
      setOuterTableData(inititalVals.directPurchaseData);
      setSelectedRows(inititalVals.directPurchaseData);
      setSelectedRowKeys(keys);
      form.setFieldsValue(inititalVals);
    } else {
      setOuterTableData();
      setSelectedRows([]);
      setSelectedRowKeys([]);
      form.setFieldsValue({
        amount: 0,
        tds: 0,
      });
    }
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const setModalVisible = () => {
    setVisible(true);
  };

  const cancel = () => {
    setVisible(false);
  };

  const purchaseSelected = () => {
    let amount = 0;
    let tds = 0;
    let newSelectedRows = [...selectedRows];
    if (newSelectedRows) {
      if (!isEmpty(outerTableData)) {
        newSelectedRows = [...new Set([...outerTableData, ...selectedRows])];
      }
      for (let i = 0; i < newSelectedRows.length; i++) {
        amount = amount + newSelectedRows[i].billAmount;
        tds = newSelectedRows[i].tds ? tds + newSelectedRows[i].tds : tds;
      }
      form.setFieldsValue({
        amount,
        tds,
      });
      setOuterTableData(newSelectedRows);
      setVisible(false);
    }
  };

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        disabled={location && location.state && location.state.isViewOnly}
        initialValues={{
          paymentDate: dayjs(),
        }}
        onFinish={onFinish}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="paymentDate"
              label="Payment Date"
              rules={[{ required: true, message: "Payment Date is required." }]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="voucherTypeId"
              label="Voucher Type"
              rules={[{ required: true, message: "Voucher Type is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {voucherType.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="accountId"
              label="Account"
              rules={[{ required: true, message: "Account is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onSelect={accountChanged}
              >
                {getCreditors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {form.getFieldValue("accountId") && (
          <Button type="primary" onClick={setModalVisible}>
            Select Direct Purchase
          </Button>
        )}
        {outerTableData && outerTableData.length > 0 && (
          <TableComponent
            columns={outerColumns}
            tableData={outerTableData}
            clientSideRender={true}
          />
        )}
        <Modal
          title="Select Direct Purchase"
          open={visible}
          onOk={purchaseSelected}
          onCancel={cancel}
          width={1000}
          okText="Save"
          destroyOnClose={true}
        >
          <TableComponent
            rowKey="id"
            columns={innerColumns}
            tableData={innerTableData}
            rowSelection={rowSelection}
            clientSideRender={true}
          />
        </Modal>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="narration"
              label="Narration"
              rules={[
                { required: true, message: "Narration is required." },
                {
                  max: 100,
                  message: "Narration should be maximum of 100 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Amount" name="amount">
              <InputNumber
                disabled={outerTableData && outerTableData.length > 0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="TDS" name="tds">
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingSaveButton}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                navigate("/portal/onAccountPayment");
              }}
              disabled={false}
            >
              {location && location.state && location.state.isViewOnly
                ? "Close"
                : "Cancel"}
            </Button>
          </Col>
        </Row>
      </Form>
      {location && location.state && location.state.isViewOnly && (
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}
    </>
  );
}

export default AddOnAccountPayment;
